module.exports = __webpack_public_path__ + "img/199.c58a94f7.jpg";